__webpack_require__.p = "/department-refactor/referrals/";